<template>
  <div class="sales-rep-widget-scroll table-responsive p-3">
    <table class="table table-bordered table-sm sales-rep-widget-table mb-0">
      <thead>
        <tr>
          <th>Status Date</th>
          <th>Org Name</th>
          <th>Contract Num</th>
          <th>Cancelled Reason Subtype</th>
          <th>SC Forecast Commission</th>
          <th>New Supplier</th>
          <th>Opp Type</th>
        </tr>
      </thead>
      <tbody v-if="items.length">
        <tr v-for="item in items" :key="item.id">
          <td>{{ formatDate(item.status_date) }}</td>
          <td>{{ item.organization_name || '—' }}</td>
          <td>
            <router-link
              v-if="item.id"
              :to="contractLink(item)"
              class="text-teal"
            >
              {{ item.contract_number || '—' }}
            </router-link>
            <span v-else>{{ item.contract_number || '—' }}</span>
          </td>
          <td class="sales-rep-wrap-cell">
            <div class="sales-rep-cell-content">{{ item.cancelled_reason_subtype || '—' }}</div>
          </td>
          <td class="text-end">{{ formatCurrency(item.sc_forecast_total_commission) }}</td>
          <td>{{ item.new_supplier || '—' }}</td>
          <td>{{ item.opp_type || '—' }}</td>
        </tr>
      </tbody>
      <tbody v-else>
        <tr>
          <td colspan="7" class="text-center text-muted py-3">No cancelled contracts</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'SalesRepCancelledContractsTable',
  props: {
    items: { type: Array, default: () => [] },
  },
  setup() {
    const formatDate = (value) => {
      if (!value) return '—';
      const d = new Date(value);
      if (isNaN(d.getTime())) return value;
      return d.toLocaleDateString('en-GB');
    };

    const formatCurrency = (value) => {
      const n = Number(value);
      if (!Number.isFinite(n)) return '£0.00';
      return new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: 'GBP',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(n);
    };

    const contractLink = (item) => ({
      path: `/crm/edit-contract/${item.id}`,
      query: { for: 'contracts' },
    });

    return { formatDate, formatCurrency, contractLink };
  },
};
</script>
